<template>
  <div style="padding-left: 2%">
    <h1
      class="lead"
      style="font-size: 24px"
    >Welcome to the Ship zone</h1>
    <hr />

    <div
      v-if="showPallets"
      class="home-pallets"
    >
      <div class="home-pallets-head">
        <h4><i class="fa fa-plane"></i> Latest pallets</h4>
        <router-link to="/pallets">All pallets <i class="fa fa-angle-right"></i></router-link>
      </div>

      <p
        v-if="palletsLoaded && pallets.length == 0"
        class="home-pallets-empty"
      >
        No pallets yet. A pallet appears here after orders are sent to Int Shipment with a pallet number.
      </p>

      <div class="row">
        <div
          class="col-sm-6 col-lg-4"
          v-for="p in pallets"
          :key="p.pallet_id"
        >
          <router-link
            :to="'/pallets?pallet=' + p.pallet_id"
            tag="div"
            class="pallet-card"
            :class="p.is_completed ? 'pallet-card-done' : 'pallet-card-open'"
          >
            <div class="pallet-card-top">
              <strong>{{ p.tracking_number }}</strong>
              <span
                class="label"
                :class="p.is_completed ? 'label-success' : 'label-warning'"
              >{{ p.is_completed ? 'Completed' : 'Not completed' }}</span>
            </div>
            <div class="pallet-card-sub">
              <span v-if="p.flight_date">Flight {{ p.flight_date }} · </span>{{ p.orders_count }} orders ·
              {{ p.arrived_count }} arrived · {{ p.delivered_count }} delivered
            </div>
            <div class="pallet-card-money">
              <div>
                <small>Income</small>
                <span>{{ p.income | usdFormat }}</span>
              </div>
              <div>
                <small>Expenses</small>
                <span>{{ p.expense | usdFormat }}</span>
              </div>
              <div>
                <small>{{ p.is_completed ? 'Final profit' : 'Provisional profit' }}</small>
                <span :class="p.profit < 0 ? 'money-bad' : 'money-good'">{{ p.profit | usdFormat }}</span>
              </div>
            </div>
            <div
              v-if="!p.is_completed"
              class="pallet-card-note"
            >
              <div
                v-for="reason in palletReasons(p)"
                :key="reason"
              ><i class="fa fa-exclamation-triangle"></i> {{ reason }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <!-- <button
      type="button"
      class="btn"
      @click="sendOtp()"
    >
      otp
    </button> -->

    <div v-if="!loggedInUserData.is_staff">
      <div v-if="
          !loggedInUserData.phone_number ||
          !loggedInUserData.address ||
          !loggedInUserData.email ||
          !loggedInUserData.full_name
        ">
        <!-- !loggedInUserData.default_branch_id_fk -->
        <h5
          class="lead"
          style="font-size: 18px"
        >
          Please fill out these information
        </h5>
        <v-alert
          :value="successResponse"
          type="success"
        >
          The process was successful
        </v-alert>
        <v-alert
          :value="errorResponse"
          type="error"
        >
          {{ errorMessages.email }}
          {{ errorMessages.phone_number }}
        </v-alert>
        <form @submit.prevent="submitForm">
          <!-- <v-flex
            @click="emailHint = false"
            xs10
            sm10
            md5
            v-if="!loggedInUserData.default_branch_id_fk"
          >
            <v-select
              :items="branchesList"
              v-model="customerInfoData.default_branch_id_fk"
              autocomplete
              label="Branch"
              :error-messages="errors.collect('Branch')"
              v-validate="'required'"
              data-vv-name="Branch"
            />
          </v-flex> -->

          <v-flex
            @click="emailHint = false"
            xs10
            sm10
            md5
            v-if="!loggedInUserData.full_name"
          >
            <v-text-field
              label="Full name"
              v-model="customerInfoData.full_name"
              :error-messages="errors.collect('Full name')"
              v-validate="'required'"
              data-vv-name="Full name"
            >
            </v-text-field>
          </v-flex>

          <v-flex
            @click="emailHint = true"
            xs10
            sm10
            md5
            v-if="!loggedInUserData.email"
          >
            <v-text-field
              label="Email"
              v-model="customerInfoData.email"
            > </v-text-field>
            <div
              v-if="emailHint === true"
              style="background-color: #ee9600; border-radius: 5px"
            >
              <p style="color: white; padding: 2%;">
                The email must be a real email, because every actions on your order will send to
                this email
              </p>
            </div>
          </v-flex>

          <v-flex
            @click="emailHint = false"
            xs10
            sm10
            md5
            v-if="!loggedInUserData.phone_number"
          >
            <div
              class="d-flex"
              style="align-items: center"
            >
              <div style="font-size: 16px; margin-right: 10px">+964</div>
              <v-text-field
                label="Phone Number"
                placeholder="7701234567"
                v-model="customerInfoData.phone_number"
                :error-messages="errors.collect('Phone Number')"
                type="number"
                v-validate="'required'"
                data-vv-name="Phone Number"
              >
              </v-text-field>
            </div>
          </v-flex>

          <v-flex
            @click="emailHint = false"
            xs10
            sm10
            md5
            v-if="!loggedInUserData.address"
          >
            <v-text-field
              label="Address"
              v-model="customerInfoData.address"
              :error-messages="errors.collect('Address')"
              v-validate="'required'"
              data-vv-name="Address"
            >
            </v-text-field>
          </v-flex>

          <v-flex
            xs10
            sm10
            md5
          >
            <v-btn
              type="submit"
              style="height:auto; width: 100%; margin-bottom: 5%"
              color="success"
            >Save</v-btn>
          </v-flex>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  mounted() {
    this.getLoggedInUser()
    this.assignUserData()
    this.openHome()
    // this.getBranchesList()
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      branchesList: [],
      fillCustomerInfoUrl: 'api/users/web/create-profile',
      emailHint: false,
      errorResponse: false,
      successResponse: false,
      errorMessages: {
        email: '',
        phone_number: ''
      },
      successMessage: '',
      showPallets: false,
      palletsLoaded: false,
      pallets: [],
      loggedInUserData: {},
      customerInfoData: {
        full_name: '',
        email: '',
        phone_number: '',
        address: ''
      }
    }
  },

  methods: {
    // sendOtp() {
    //   let token = localStorage.getItem('access_token')
    //   axios
    //     .get('api/test-otp', { headers: { Authorization: 'Bearer ' + token } })
    //     .then(res => {
    //       console.log(res.data)
    //     })
    // },

    // getBranchesList() {
    //   this.branchesList = []

    //   let token = localStorage.getItem('access_token')
    //   axios
    //     .get('api/branch/list', { headers: { Authorization: 'Bearer ' + token } })
    //     .then(response => {
    //       response.data.forEach(r => {
    //         this.branchesList.push({ text: r.branch_name, value: r.branch_id })
    //       })
    //     })
    // },

    // Admins who may see the pallet report stay here and get the latest pallets;
    // everyone else goes on to My Orders as before.
    openHome(triesLeft = 10) {
      if (this._isDestroyed) {
        return
      }
      if (!this.loggedInUserData || !this.loggedInUserData.is_staff) {
        // customers go straight on, exactly as before
        this.$router.push('/my-order')
        return
      }
      if (localStorage.getItem('user_permissions') === null && triesLeft > 0) {
        // right after login the permissions can still be on their way
        setTimeout(() => this.openHome(triesLeft - 1), 300)
        return
      }
      if (this.loggedInUserData && this.loggedInUserData.is_staff && this.$_has_perm('view_pallet_report')) {
        this.showPallets = true
        this.getPallets()
      } else {
        this.$router.push('/my-order')
      }
    },

    // why a pallet is not completed yet (it completes by itself)
    palletReasons(p) {
      const reasons = []
      const missing = p.missing_expenses || []
      if (p.orders_count == 0) {
        reasons.push('No orders yet')
      }
      if (p.waiting_invoice_count > 0) {
        reasons.push(p.waiting_invoice_count + (p.waiting_invoice_count == 1 ? ' order' : ' orders') + ' not weighed in Erbil yet')
      }
      if (missing.length > 0) {
        reasons.push('Not entered yet: ' + missing.join(', '))
      }
      return reasons
    },

    getPallets() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/pallets', { params: { limit: 6 }, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.pallets = response.data
        })
        .catch(() => { })
        .then(() => {
          this.palletsLoaded = true
        })
    },

    assignUserData() {
      this.customerInfoData.full_name = this.loggedInUserData.full_name
      this.customerInfoData.email = this.loggedInUserData.email
      this.customerInfoData.phone_number = this.loggedInUserData.phone_number
      this.customerInfoData.address = this.loggedInUserData.address
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          let token = localStorage.getItem('access_token')

          let phone = this.customerInfoData.phone_number
          if (!this.customerInfoData.phone_number.startsWith('+964')) {
            phone = '+964' + this.customerInfoData.phone_number
          }

          const payload = {
            ...this.customerInfoData,
            phone_number: phone
          }

          axios.post(this.fillCustomerInfoUrl, payload, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(() => {
            this.errorResponse = false
            this.successResponse = true
            this.getUser()
          }).then(() => {
            this.$router.push('/my-order')
          }).catch(error => {
            if (error.response.data.message.email) {
              this.errorMessages.phone_number = ''
              this.errorMessages.email = error.response.data.message.email[0]
            } else if (error.response.data.message.phone_number) {
              this.errorMessages.email = ''
              this.errorMessages.phone_number = error.response.data.message.phone_number[0]
            } else if (error.response.data.message) {
              this.errorMessages.email = ''
              this.errorMessages.phone_number = error.response.data.message
            }
            this.errorResponse = true
            this.successResponse = false
          }).then(() => {
            let b = this
            setTimeout(function () {
              b.errorResponse = false
            }, 4000)
          })
        }
      })
    },

    getUser() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/me', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          localStorage.setItem('user_data', JSON.stringify(response.data))
          this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
        })
        .then(() => {
          location.reload(true)
        })
    }
  }
}
</script>

<style scoped>
.home-pallets {
  padding-right: 2%;
}

.home-pallets-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.home-pallets-head h4 {
  margin: 0;
  font-weight: 600;
}

.home-pallets-empty {
  color: #777;
}

.pallet-card {
  margin-bottom: 20px;
  padding: 16px 18px;
  background: #fff;
  border: 1px solid #e3e3e3;
  border-left: 5px solid #e67e22;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: box-shadow 0.15s;
}

.pallet-card:hover {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.14);
}

.pallet-card-done {
  border-left-color: #27ae60;
}

.pallet-card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 17px;
}

.pallet-card-sub {
  margin: 6px 0 14px;
  color: #777;
  font-size: 13px;
}

.pallet-card-money {
  display: flex;
  justify-content: space-between;
}

.pallet-card-money small {
  display: block;
  color: #888;
}

.pallet-card-money span {
  font-size: 16px;
  font-weight: 600;
}

.money-good {
  color: #27ae60;
}

.money-bad {
  color: #d9534f;
}

.pallet-card-note {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #e3e3e3;
  color: #e67e22;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue